<template>

    <div class="registeredCard">
        <div class="cardTitle">
			{{'components/payment/registered-card.use-registered-card' | trans}}: {{registeredCardPan}}
            <img src="/assets/img/visa.svg" alt="visa">
        </div>
        <div class="wrap">
            <div class="inputWrap cvv">
                <span>CVV</span>
                <input v-model="registeredCardCvv" type="text" class="process-paymnet-cvv" maxlength="4">
            </div>
            <div v-if="registeredCardCvv">
                <PulseLoader v-if="loading" size="8px" color="#00B2FF"/>
                <button v-else @click="processPayment" class="btn">{{'components/payment/registered-card.process-payment' | trans}}</button>
            </div>

        </div>
    </div>
</template>

<script>

    import helper from '../../services/helper'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        components: {
            PulseLoader
        },
        data() {
            return {
                registeredCardCvv: null,
            }
        },
        props: {
            registeredCardPan: {
                type: String,
                default: null
            },
            registeredPaymentMethodId: {
                type: String,
                default: ''
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            processPayment: function () {
                let payLoad = {
                    registeredPaymentMethodId: this.registeredPaymentMethodId,
                    cvv: this.registeredCardCvv
                };

                this.$emit('processPayment', payLoad)
            }
        }
    }
</script>

<style scoped>
    .alert {
        border: 1px solid red;
    }
</style>
